module.exports = __webpack_public_path__ + "img/icn-fishing.44bea47a.png";